import { render, staticRenderFns } from "./article-list.vue?vue&type=template&id=a3e049f2&scoped=true&"
import script from "./article-list.vue?vue&type=script&lang=js&"
export * from "./article-list.vue?vue&type=script&lang=js&"
import style0 from "./article-list.vue?vue&type=style&index=0&id=a3e049f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e049f2",
  null
  
)

export default component.exports